import { Dialog } from '@mui/material';
import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: flex;
  gap: 0.375rem;
`;

export const StyledDialog = styled(Dialog)<{ align?: string }>`
  && .MuiDialog-paper {
    margin: 1rem 2rem;
    max-height: 99vh;
    align-self: ${(props) => (props.align ? props.align : `center`)};
  }

  && .MuiDialogTitle-root {
    padding: 0.65rem 1rem;
    font-weight: 600;
  }

  && .MuiDialogContent-root {
    padding: 1rem 1.5rem;
    min-width: 600px;
    max-width: 100%;

    && .MuiTextField-root {
      width: 100%;
      padding: 5rem;
    }
  }
  && .MuiDialogActions-root {
    padding: 0.75rem 1.5rem;
  }
`;
